import { Injectable, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LodashService, MessageDialogConfig, MessageDialogService } from '@nx-customer-apps/components';
import { ApiErrors, ApiErrorsSources } from '@nx-customer-apps/shared/enums';
import { SnackbarService } from '@nx-customer-apps/shared/services';
import { ApiErrorsMessageDictionary } from '@nx-customer-apps/shared/utils';

@Injectable({
    providedIn: 'root'
})
export class ErrorService {
    private snackbarService = inject(SnackbarService);
    private translate = inject(TranslateService);
    private messageDialogService = inject(MessageDialogService);

    private readonly snackbarDelay = 500;

    public showSnackbar(key: ApiErrors, options?: { duration?: number }): void {
        const messageKey = ApiErrorsMessageDictionary[key];
        const message = this.translate.instant(messageKey || ApiErrorsMessageDictionary[ApiErrors.Generic]);
        const duration = !LodashService.isNil(options?.duration) ? options?.duration : 5000;
        const action = this.translate.instant('COMMON.BUTTONS.GOT_IT');
        setTimeout(() => {
            this.snackbarService.showInfo(message, {
                duration,
                action
            });
        }, this.snackbarDelay);
    }

    public showErrorDialog(key: ApiErrors, errorSource: ApiErrorsSources): void {
        const messageKey = ApiErrorsMessageDictionary[key];
        const config: MessageDialogConfig = {
            title: this.translate.instant(messageKey || ApiErrorsMessageDictionary[ApiErrors.Generic]),
            cancelButton: this.translate.instant('COMMON.BUTTONS.CLOSE')
        };
        switch (errorSource) {
            case ApiErrorsSources.QuoteAssist:
                config.descriptions = [
                    this.translate.instant('ERROR_DIALOG.QUOTE_ASSIST.DESCRIPTION_1'),
                    this.translate.instant('ERROR_DIALOG.QUOTE_ASSIST.DESCRIPTION_2')
                ];
                config.icon = 'warning';
                config.iconType = 'warning';
                break;
            default:
                break;
        }
        this.messageDialogService.showDialog(config);
    }
}
